export default "__VITE_ASSET__D6ADG6mo__"